module.exports = __webpack_public_path__ + "img/ExamenLabs.4bd016b1.jpg";